import React, {useEffect, useState} from 'react'
import {connect, useSelector} from "react-redux";
import {Card, CardBody, CardTitle} from "reactstrap";

// components
import IconsForm from "./_form";
import IconsList from "./_list";
import LinkedIcon from "./LinkedIcon";
import {showLoader} from "../../../../components/loader/loader";
import {GenericButton} from "../../../../components/buttons/customButtons";

// labels
import {ADD_STATE, REMOVE_STATE, setForm, setItem} from "../../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../../redux/selectors";



const Icons = (props) => {
    const path = `${props.path}/icons`;
    const componentState = useSelector(state => getStateByPath(state, path));
    const {loading} = componentState?.data || false;

    const [showFormModal, setShowFormModal] = useState(false);

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    const onCreateItem = () => {
        props.setItem(path, null);
        props.setForm(path)
        setShowFormModal(!showFormModal);
    }

    const onEditItem = (data) => {
        props.setItem(path, data);
        props.setForm(path, true, false, false)
        setShowFormModal(!showFormModal);
    }

    const handleShowFormModal = () => setShowFormModal(!showFormModal);



    return <>
        {loading && showLoader()}

        <Card className={'internal-card'}>
            <CardTitle className="internal-title-card">
                <i className="far fa-edit"/> Iconos
                <div className="top-right actions">
                    <GenericButton
                        style={'table'}
                        label={'Nuevo Icono'}
                        toolTip={'Nuevo Icono'}
                        icon={'fa-plus'}
                        permission={'add'}
                        onClick={onCreateItem}
                    />
                </div>
            </CardTitle>
            <CardBody className={'internal-body-card'}>
                <LinkedIcon path={props.path} />
                <IconsList
                    path={props.path}
                    toggleModal={handleShowFormModal}
                    onEdit={onEditItem}
                />
            </CardBody>
        </Card>

        {
            showFormModal && <IconsForm
                path={props.path}
                isOpen={showFormModal}
                toggle={handleShowFormModal}
            />
        }
    </>
}

const mapStateToProps = state => ({})
const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setItem, setForm
})

export default connect(mapStateToProps, mapActionsToProps)(Icons);